// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2qSOP","content":"style_content__3U2tw","image":"style_image__2P0aw","inputWrapper":"style_inputWrapper__1owyi"};